/** Shared data contract. Transport authentication and channel permissions belong to the server. */
export interface ChatAuthor {
  readonly id: string;
  readonly displayName: string;
  readonly kind: 'guest' | 'account' | 'bot';
}

export interface ChatMessage {
  readonly id: string;
  readonly sequence: number;
  readonly channelId: string;
  readonly kind: 'message' | 'system';
  readonly author: ChatAuthor | null;
  readonly text: string;
  /** Server timestamp in milliseconds since the Unix epoch. */
  readonly createdAt: number;
  readonly clientMessageId?: string;
}

export interface ChatSettings {
  readonly globalEnabled: boolean;
  readonly guestGlobalEnabled: boolean;
  readonly guestMatchEnabled: boolean;
}

export const CHAT_HISTORY_LIMIT = 100;
export const CHAT_MESSAGE_MAX_CHARACTERS = 280;
export const CHAT_MESSAGE_MAX_BYTES = 2_048;
